import React, { Fragment, useContext, useState } from "react";
// import { DIMENSIONS } from "utils/Dimensions";
import ArrowAndViewType from "./ArrowAndViewType";
// import Collaborators from "./Collaborators";
import Find from "./Find";
import { observer } from "mobx-react";
import TableButtons from "./TableButtons";
import PivotButtons from "./PivotButtons";
// import Triggers from "./Triggers";
import ActionButtons from "./ActionButtons";
import styled from "styled-components";
import { Grid, Button } from "@material-ui/core";
import Settings from "./Settings";
import SaveResetButtons from "../SaveResetButtons";
import { ContainerStoreContext } from "../ContainerStore";
import RemindersPopup from "../Reminders/RemindersPopup";
import COLORS from "scss/colors.module.scss";
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';

import MailModal from "./BulkEmails/MailModal";
import { MailOutline } from "@material-ui/icons";
function Toolbar(props) {
  const containerStore = useContext(ContainerStoreContext);

  let isSubSheetView =
    props.store?.view?.type == "table" &&
    props.store?.view?.list_id &&
    props.store?.view?.options?.main_list_id &&
    props.store?.view?.list_id != props.store?.view?.options?.main_list_id;

  const showModal = () => {
    if (props.store?.noOfRecordsSelected === 0) {
      props.store.closeMailModal();
      window.appStore.notificationStore.showNotification(
        "Please select the rows for which bulk emails are to be sent",
        "error"
      );
    } else {
      props.store.showMailModal();
    }
  };

  const handleBulkPrint = () => {
    let rowIdsList = [];
    let selectedNodes = props.store?.gridApi.getSelectedNodes();
    selectedNodes.map((node) => {
      if (node?.data?.row_id) {
        rowIdsList.push(node.data.row_id);
      }
    });
    if(rowIdsList.length == 1) {
      containerStore?.handlePrint(rowIdsList[0]);
    } else if(rowIdsList.length > 1) {
      containerStore?.handleBulkPrint(rowIdsList);
    }
    
    //unselect all rows
    props.store.resetSelectedRecordsCount();
    props.store?.gridApi.deselectAll();
    let parentDOM = document.getElementById(props.store.gridId);
    let array = Array.from(
      parentDOM.getElementsByClassName("rowIdSelection")
    );
    parentDOM.querySelectorAll(
      "input[id='defaultChecked']"
    )[0].checked = false;
    array.map((row) => {
      if (row.checked) {
        row.checked = false;
      }
    });
  };

  const closeModal = () => {
    props.store.closeMailModal();
  };

  if (
    props.store?.noOfRecordsSelected >= 1 
  ) {
    return (
      <Fragment>
        {props.store.isMailModalVisible && (
          <MailModal
            store={props.store}
            showMailMergeModal={props.store.isMailModalVisible}
            closeModal={closeModal}
          />
        )}
        <Grid container direction="row" justify="space-between">
          <Grid item>
            <StyledDiv className="d-flex">
              <ActionButtons
                noOfRecordsSelected={props.store?.noOfRecordsSelected}
                customEventsList={props.store?.customEventsList}
                store={props.store}
                params={props.params}
                gridApi={props.store?.gridApi}
              />
            </StyledDiv>
          </Grid>
          <Grid item>
            <StyledDiv className="d-flex">
            {!isSubSheetView && (
              <StyledButton
                variant="text"
                onClick={handleBulkPrint}
              >
                <PrintOutlinedIcon size={18} style={{ height: 18, width: 18 }} /> 
                <StyledBtnDiv>
                  {props.store?.noOfRecordsSelected > 1 ? ("bulk print(" + props.store?.noOfRecordsSelected + ")") : ("print(" + props.store?.noOfRecordsSelected + ")")}
                </StyledBtnDiv>
              </StyledButton>
            )}
            {props.store?.listConfig?.list?.is_log_sheet != 1 &&
              props.store.props.listConfig.listPermissions.can_send_email == "1" && (
              <StyledButton variant="text" onClick={() => showModal()}>
                <MailOutline size={18} style={{ height: 18, width: 18 }} />
                <StyledBtnDiv>
                  {"Bulk Email(" + props.store?.noOfRecordsSelected + ")"}
                </StyledBtnDiv>
                {/* {"Bulk Email(" + props.store?.noOfRecordsSelected + ")"} */}
              </StyledButton>
            )}
            </StyledDiv>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
  return (
    <StyledDiv className="d-flex">
      <ArrowAndViewType />
      {/* <Collaborators /> */}
      {props.store?.view?.type === "table" ? (
        <TableButtons {...props} />
      ) : (
        <div style={{ flex: 1 }} />
      )}
      <StyledSaveResetButtons
        open={
          containerStore.saveResetButtonsPosition === "toolbar" &&
          containerStore.isSaveResetButtonsOpen
        }
        type="toolbar"
        iconHidden
      />
      {/* <div style={{ flex: 1 }} /> */}
      {props.store && <Find store={props.store} />}
      {props.store?.view?.type === "pivot" && <PivotButtons {...props} />}
      {containerStore.permissions?.isAdmin() && (
        <>
          {containerStore.notificationsStore && (
            <RemindersPopup store={containerStore.notificationsStore} />
          )}
          {containerStore.remindersStore && (
            <RemindersPopup store={containerStore.remindersStore} />
          )}
          {/* <Triggers /> */}
        </>
      )}
      {props.store?.view?.type === "table" && props.store?.listConfig?.list?.is_log_sheet != 1 && (
        <StyledBtn variant="text" onClick={() => showModal()} className="d-flex">
          <MailOutline size={18} style={{ height: 18, width: 18 }} />
          <StyledBtnDiv>Bulk Email</StyledBtnDiv>
        </StyledBtn>
      )}
      <Settings />
    </StyledDiv>
  );
}
const StyledSaveResetButtons = styled(SaveResetButtons)`
  width: 400px;
`;
const StyledDiv = styled.div`
  height: 50px;
  width: 100%;
  align-items: center;
  z-index: 3;
  background-color: white;
  padding-right: 5px;
`;
const StyledButton = styled(Button)`
  height: 30px;
  margin-right: 10px;
  text-transform: uppercase !important;
`;

const StyledBtn = styled.div`
  margin: 3px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px;
  min-width: 95px;
  align-items: center;
  &:hover {
    background-color: ${COLORS.ACTIONS_HOVER};
  }
`;

const StyledBtnDiv = styled.div`
  color: #000;
  font-size: 12px;
  font-weight: 500;
  padding: 2px;
  padding-left: 5px;
`;

export default observer(Toolbar);
